import { render, staticRenderFns } from "./SidebarAddBlockModal.vue?vue&type=template&id=d593b6e2&scoped=true"
import script from "./SidebarAddBlockModal.vue?vue&type=script&lang=ts"
export * from "./SidebarAddBlockModal.vue?vue&type=script&lang=ts"
import style0 from "./SidebarAddBlockModal.vue?vue&type=style&index=0&id=d593b6e2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d593b6e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d593b6e2')) {
      api.createRecord('d593b6e2', component.options)
    } else {
      api.reload('d593b6e2', component.options)
    }
    module.hot.accept("./SidebarAddBlockModal.vue?vue&type=template&id=d593b6e2&scoped=true", function () {
      api.rerender('d593b6e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/view-editor/SidebarAddBlockModal.vue"
export default component.exports